import { render, staticRenderFns } from "./NewDomain.vue?vue&type=template&id=2103a3e2&scoped=true&"
import script from "./NewDomain.vue?vue&type=script&lang=js&"
export * from "./NewDomain.vue?vue&type=script&lang=js&"
import style0 from "./NewDomain.vue?vue&type=style&index=0&id=2103a3e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103a3e2",
  null
  
)

export default component.exports